import { Money } from 'types';
import { sentenceCase } from 'lib/humanize/humanize';
import { LineItem } from 'components/payments/primitives';
import { FeesDisclaimer } from 'components/Disclaimers';

interface PayableAtPropertyLineItemProps {
  formattedCheckIn: string;
  description: string;
  charge: Money;
}

const PayableAtPropertyLineItem = ({ formattedCheckIn, description, charge }: PayableAtPropertyLineItemProps) => (
  <LineItem title={sentenceCase(description)} totals={[charge]}>
    Charged in local currency. Payable at property at check-in on {formattedCheckIn}
    <FeesDisclaimer.Link />
  </LineItem>
);

export default PayableAtPropertyLineItem;
